import LanguageDetector from 'i18next-browser-languagedetector'

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const resources = {
  en: {
    jobs: require('./en/jobs.json'),
    common: require('./en/common.json'),
    header: require('./en/header.json'),
    hero: require('./en/hero.json'),
    cases: require('./en/cases.json'),
    ai: require('./en/ai.json'),
    video: require('./en/video.json'),
    team: require('./en/team.json'),
    faq: require('./en/faq.json'),
    callToAction: require('./en/callToAction.json'),
    footer: require('./en/footer.json'),
    seo: require('./en/seo.json'),
  },
  nl: {
    jobs: require('./nl/jobs.json'),
    common: require('./nl/common.json'),
    header: require('./nl/header.json'),
    hero: require('./nl/hero.json'),
    cases: require('./nl/cases.json'),
    ai: require('./nl/ai.json'),
    video: require('./nl/video.json'),
    team: require('./nl/team.json'),
    faq: require('./nl/faq.json'),
    callToAction: require('./nl/callToAction.json'),
    footer: require('./nl/footer.json'),
    seo: require('./nl/seo.json'),
  },
} as const

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    ns: [
      'header',
      'hero',
      'cases',
      'ai',
      'video',
      'team',
      'faq',
      'callToAction',
      'footer',
      'seo',
    ],
    supportedLngs: ['en', 'nl'],
    defaultNS: 'common',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
  })

export default i18n
